<script lang="ts" module>
	import type { VariantProps } from 'tailwind-variants';
	import { Switch } from 'bits-ui';
	import { tv } from '../tv';
	import { MAIN_COLOR_VARIANTS } from '../variants';
	import Icon from '../icon/icon.svelte';
	import { Icons } from '../icon/icons';

	export const switchVariants = tv({
		base: 'inline-flex h-[1.5rem] w-[2.75rem] shrink-0 cursor-pointer items-center rounded-pill bg-transparent [box-shadow:inset_0_0_0_var(--border-width-b400)_currentColor] aria-checked:bg-(--v-main) aria-checked:text-(--v-on-main) aria-checked:[box-shadow:none] aria-[checked=false]:opacity-p300 focus-outline disabled-state',
		variants: { variant: MAIN_COLOR_VARIANTS },
		defaultVariants: { variant: 'Primary' }
	});

	export type SwitchProps = Omit<Switch.RootProps, 'child' | 'children'> &
		VariantProps<typeof switchVariants>;
</script>

<script lang="ts">
	let {
		checked = $bindable(false),
		class: className,
		onCheckedChange,
		ref = $bindable(null),
		variant,
		...rest
	}: SwitchProps = $props();
</script>

<Switch.Root
	bind:checked
	bind:ref
	class={[switchVariants({ variant }), className]}
	{onCheckedChange}
	{...rest}
>
	<Switch.Thumb
		aria-hidden="true"
		class="rounded-pill inline-flex size-[0.875rem] translate-x-[0.3125rem] items-center justify-center bg-current data-[state=checked]:size-[1.125rem] data-[state=checked]:translate-x-[1.4375rem] data-[state=checked]:bg-(--v-on-main) data-[state=checked]:text-(--v-main)"
	>
		<Icon size="100" src={Icons.Check} />
	</Switch.Thumb>
</Switch.Root>
